import { Controller } from "stimulus";

export default class extends Controller {

  connect() {
  }

  closeCalendarModal(event) {
    document
      .querySelector('.js-ListingDetail__full-calendar-section')
      .classList
      .remove('ListingDetail__reveal')
  }
}
